import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import APSLogo from "../../../components/ui/APS Logo.svg";

const TermsPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Nav bar */}
      <header className="border-b border-surface-border px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img src={APSLogo} alt="APS Logo" className="h-11 w-auto object-contain" />
        </Link>
        <Link to="/" className="text-sm text-brand-muted hover:text-primary transition-colors">
          ← Back to home
        </Link>
      </header>

      {/* Content */}
      <main className="max-w-3xl mx-auto px-6 py-12">
        <div className="mb-10">
          <h1 className="text-3xl font-extrabold text-brand-text mb-3">Terms of Service</h1>
          <p className="text-sm text-brand-muted">
            <span className="font-medium">Effective Date:</span> April 3, 2026 &nbsp;|&nbsp;
            <span className="font-medium">Last Updated:</span> April 3, 2026
          </p>
        </div>

        <div className="bg-[#F7F8FF] border border-[#E0DCFF] rounded-xl px-5 py-4 mb-8">
          <p className="text-sm text-[#5B4FCF] font-medium">
            By accessing or using AIPolicyScan, you agree to these Terms of Service. Please read them carefully.
          </p>
        </div>

        {[
          {
            n: 1,
            title: "Acceptance of Terms",
            body: "By creating an account or using the Service, you agree to be bound by these Terms and our Privacy Policy. If you do not agree, do not use the Service.",
          },
          {
            n: 2,
            title: "Use of the Service",
            body: "You may use the Service solely for lawful business purposes. You are responsible for all activity under your account. You agree not to misuse, reverse-engineer, or attempt to gain unauthorized access to any part of the Service.",
          },
          {
            n: 3,
            title: "Account Registration",
            body: "You must provide accurate and complete information when creating your account and keep it up to date. You are responsible for maintaining the confidentiality of your credentials.",
          },
          {
            n: 4,
            title: "Subscription and Payment",
            body: "Certain features require a paid subscription. Fees are billed in advance on a recurring basis. All payments are processed by Stripe. Subscription fees are non-refundable except as required by applicable law.",
          },
          {
            n: 5,
            title: "Intellectual Property",
            body: "All content, features, and functionality of the Service are owned by AIPolicyScan and protected by applicable intellectual property laws. You retain ownership of content you submit to the Service.",
          },
          {
            n: 6,
            title: "Disclaimer of Warranties",
            body: 'The Service is provided "as is" and "as available" without warranties of any kind. Analysis outputs are for informational purposes only and do not constitute legal advice. We do not warrant that the Service will be uninterrupted or error-free.',
          },
          {
            n: 7,
            title: "Limitation of Liability",
            body: "To the maximum extent permitted by law, AIPolicyScan shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Service.",
          },
          {
            n: 8,
            title: "Termination",
            body: "We reserve the right to suspend or terminate your access to the Service at any time for violation of these Terms or for any other reason with or without notice.",
          },
          {
            n: 9,
            title: "Governing Law",
            body: "These Terms are governed by the laws of the United States. Any disputes shall be resolved in the courts of competent jurisdiction in the United States.",
          },
          {
            n: 10,
            title: "Changes to Terms",
            body: 'We may update these Terms from time to time. We will notify you of material changes by email or in-product notice. Continued use of the Service after changes are posted constitutes your acceptance of the updated Terms.',
          },
          {
            n: 11,
            title: "Contact",
            body: null,
            contactEmail: "legal@aipolicyscan.ai",
          },
        ].map(({ n, title, body, contactEmail }) => (
          <section key={n} className="mb-8">
            <h2 className="text-base font-bold text-brand-text mb-3">
              {n}. {title}
            </h2>
            <p className="text-sm text-brand-muted leading-relaxed">
              {body ||
                (contactEmail && (
                  <>
                    For questions about these Terms, contact us at{" "}
                    <a href={`mailto:${contactEmail}`} className="text-primary hover:underline">
                      {contactEmail}
                    </a>
                    .
                  </>
                ))}
            </p>
          </section>
        ))}

        {/* Footer note */}
        <div className="mt-12 pt-8 border-t border-surface-border text-center">
          <p className="text-xs text-brand-light">© 2026 AIPolicyScan. All rights reserved.</p>
          <div className="flex justify-center gap-5 mt-3">
            <Link to="/privacy-policy" className="text-xs text-brand-muted hover:text-primary transition-colors">
              Privacy Policy
            </Link>
            <Link to="/" className="text-xs text-brand-muted hover:text-primary transition-colors">
              Back to Home
            </Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsPage;
